import axios from "axios";
import qs from "qs"
import {getToken} from "../functions";
import {RequestBodyInterface} from "../interface";
import {fetchAxiosError} from "./functions";
import {BACKEND_URL} from "../constants";

export const getRequest: (url: string, sendData: any) => Promise<RequestBodyInterface> = (url, sendData) =>  {
    const authorization: string = getToken();
    return new Promise((resolve, reject) => {
        axios.get(
            url,
            {
                "params": sendData,
                "headers": {
                    "Authorization": authorization,
                    "Access-Token": authorization
                }
            }
        ).then((res) => {
            const responseCode = res?.data?.code;
            if (String(responseCode) === "0") {
                resolve(res.data);
            } else if (responseCode === "TOKEN_INVALID") {
                localStorage.removeItem("access_token");
            }
        }).catch((error) => {
            const {response} = error;
            const responseCode = response?.data?.code;
            const responseMessage = response?.data?.message;
            if (responseCode === 500 && responseMessage) {
                // requestError(responseMessage);
            }
        })
    })
}

export const postRequest: (url: string, sendData: any) => Promise<RequestBodyInterface> = (url, sendData) => {
    const authorization: string = getToken();
    return new Promise((resolve, reject) => {
        axios.post(
            `${BACKEND_URL}${url}`,
            qs.stringify(sendData),
            {
                headers: {
                    Authorization: authorization,
                    "Access-Token": authorization
                },
                withCredentials: true,
            }
        ).then((res: any) => {
            const responseCode = res?.data?.code;
            if (String(responseCode) === "0") {
                resolve(res.data);
            } else if (responseCode === "TOKEN_INVALID") {
                localStorage.removeItem("access_token");
            } else {
                resolve(res);
            }
        }).catch((error) => {
            if (error.response) {
                // 服务器响应了请求，但返回了错误状态码
                // 处理HTTP错误
                console.error(error.response.status); // 响应的HTTP状态码
                console.error(error.response.data); // 服务器提供的错误信息
                console.error(error.response.headers); // 响应头
                reject(error.response)
                // reject(response)
            } else if (error.request) {
                // 请求已经发起，但没有收到响应
                // 处理网络错误或请求未被发送
                console.error(error.request); // 浏览器的 XMLHttpRequest 对象
            } else {
                // 设置请求时触发了错误
                console.error('Error', error.message); // 错误信息
                fetchAxiosError(error.message)
            }
        })
    })
}